import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mp = '@media print';
  return {
    container: _defineProperty({
      flex: '1',
      position: 'relative',
      transform: 'translateZ(0)',
      overflowY: 'auto'
    }, mp, {
      overflow: 'visible !important'
    })
  };
};
export default generateStyle;